import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.remove`;

export const INIT = `${SCOPE}/INIT`;
export const REMOVE_DASHBOARD = `${SCOPE}/REMOVE_DASHBOARD`;
export const REMOVE_DASHBOARD_BY_ID = `${SCOPE}/REMOVE_DASHBOARD_BY_ID`;
